interface SkillDatainterface {
    name: string;
    percent: number;
}

const SkillData: SkillDatainterface[] = [
    {
        name: "Skill-1",
        percent: 0,
    }, {
        name: "Skill-2",
        percent: 20,
    }, {
        name: "Skill-3",
        percent: 40,
    }, {
        name: "Skill-4",
        percent: 60,
    }, {
        name: "Skill-5",
        percent: 80,
    }, {
        name: "Skill-6",
        percent: 100,
    }
];

export { SkillData };
